<div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
    <table class="table">
        <thead>
            <th>Printer Name</th>
            <th>Model</th>
            <th>Identifier</th>
            <th class="text-right" [hidden]="eventFinished">Actions</th>
        </thead>
        <tbody>
            <tr *ngFor="let printer of realFiscalPrinters">
                <td>{{printer.name}}</td>
                <td>{{printer.printerType.name}}</td>
                <td>{{printer.identifier}}</td>
                <td class="text-right" [hidden]="eventFinished">
                    <button type="button" class="btn btn-sm btn-primary"
                        (click)="unAssociatePrinterFromEventClick(printer)">Remove</button>
                </td>
            </tr>
        </tbody>
    </table>
    <ng-container *ngIf="freeRealPrinterAmount > 0">
        <div class="card" [hidden]="eventFinished">
            <div class="card-body" style="padding-bottom: 0px;">
                <div class="form-row align-items-center">
                    <div class="col">
                        <app-select label="Printer Name" [options]="availablePrinterOptions" [(model)]="printerId"
                            (modelChange)="printerSelectChange()"></app-select>
                    </div>
                    <div class="col">
                        <app-form-group-input label="Identifier" [disabled]="true"
                            [(model)]="selectedPrinter.identifier">
                        </app-form-group-input>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-sm btn-default"
                            (click)="associatePrinterToEventClick()">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
